/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeletePluginSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeletePluginRequest = {
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeletePluginSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeletePluginSecurity$outboundSchema: z.ZodMiniType<
  DeletePluginSecurity$Outbound,
  DeletePluginSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deletePluginSecurityToJSON(
  deletePluginSecurity: DeletePluginSecurity,
): string {
  return JSON.stringify(
    DeletePluginSecurity$outboundSchema.parse(deletePluginSecurity),
  );
}

/** @internal */
export type DeletePluginRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeletePluginRequest$outboundSchema: z.ZodMiniType<
  DeletePluginRequest$Outbound,
  DeletePluginRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deletePluginRequestToJSON(
  deletePluginRequest: DeletePluginRequest,
): string {
  return JSON.stringify(
    DeletePluginRequest$outboundSchema.parse(deletePluginRequest),
  );
}
